// DO NOT EDIT. Generated from packages/design-tokens/tokens.mjs by scripts/generate-design-tokens.mjs.
// Consumed by frontend/src/theme.tsx. Values are framework-agnostic; theme.tsx
// assembles createTheme() and keeps the hand-authored component overrides.

export const palette = {
    "primary": {
        "main": "#00A7A8",
        "light": "#00B8B9",
        "dark": "#008889",
        "contrastText": "#FFFFFF"
    },
    "secondary": {
        "main": "#2a496f",
        "light": "#4a6a93",
        "dark": "#1a2f4f",
        "contrastText": "#FFFFFF"
    },
    "success": {
        "main": "#2F8C6B",
        "light": "#EAF3EF"
    },
    "warning": {
        "main": "#BC8730",
        "light": "#F8F1E2"
    },
    "error": {
        "main": "#C0504E",
        "light": "#F9ECEB"
    },
    "info": {
        "main": "#43719E",
        "light": "#EEF3F8"
    },
    "background": {
        "default": "#FFFFFF",
        "paper": "#FFFFFF"
    },
    "text": {
        "primary": "#0f172a",
        "secondary": "#475569",
        "disabled": "#94a3b8"
    },
    "divider": "#e2e8f0"
} as const;

export const statusColors = {
    "success": "#2F8C6B",
    "warning": "#BC8730",
    "error": "#C0504E",
    "info": "#43719E",
    "successLight": "#EAF3EF",
    "warningLight": "#F8F1E2",
    "errorLight": "#F9ECEB",
    "infoLight": "#EEF3F8"
} as const;

export const typography = {
    "fontFamily": "\"Sofia Pro\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Helvetica\", \"Arial\", sans-serif",
    "h1": {
        "fontSize": "3rem",
        "fontWeight": 700,
        "letterSpacing": "-0.01em"
    },
    "h2": {
        "fontSize": "2.25rem",
        "fontWeight": 700,
        "letterSpacing": "-0.01em"
    },
    "h3": {
        "fontSize": "1.875rem",
        "fontWeight": 600
    },
    "h4": {
        "fontSize": "1.5rem",
        "fontWeight": 600
    },
    "h5": {
        "fontSize": "1.25rem",
        "fontWeight": 600
    },
    "h6": {
        "fontSize": "1.125rem",
        "fontWeight": 600
    },
    "subtitle1": {
        "fontSize": "1rem",
        "fontWeight": 500
    },
    "subtitle2": {
        "fontSize": "0.875rem",
        "fontWeight": 500
    },
    "body1": {
        "fontSize": "1rem",
        "fontWeight": 400
    },
    "body2": {
        "fontSize": "0.875rem",
        "fontWeight": 400
    },
    "button": {
        "fontSize": "0.875rem",
        "fontWeight": 500,
        "textTransform": "none"
    },
    "caption": {
        "fontSize": "0.75rem",
        "fontWeight": 400
    }
} as const;

export const designTokens = {
    "radius": {
        "none": 0,
        "xs": 6,
        "sm": 6,
        "md": 6,
        "lg": 8,
        "xl": 12,
        "control": 6,
        "card": 10,
        "dialog": 10,
        "pill": 9999,
        "round": "50%"
    },
    "elevation": {
        "none": 0,
        "xs": "0 1px 2px rgba(0,0,0,0.05)",
        "sm": "0 1px 3px rgba(0,0,0,0.08)",
        "md": "0 2px 4px rgba(0,0,0,0.1)",
        "lg": "0 3px 6px rgba(0,0,0,0.12)",
        "xl": "0 4px 8px rgba(0,0,0,0.16)"
    },
    "spacing": {
        "xs": 4,
        "sm": 8,
        "md": 16,
        "lg": 24,
        "xl": 32,
        "xxl": 48
    }
} as const;

export const alert = {
    "success": {
        "bg": "#EAF3EF",
        "color": "#23664e",
        "icon": "#2F8C6B"
    },
    "warning": {
        "bg": "#F8F1E2",
        "color": "#7d5a1e",
        "icon": "#BC8730"
    },
    "error": {
        "bg": "#F9ECEB",
        "color": "#853634",
        "icon": "#C0504E"
    },
    "info": {
        "bg": "#EEF3F8",
        "color": "#2e4f70",
        "icon": "#43719E"
    }
} as const;
